import { render, staticRenderFns } from "./ipf-item.vue?vue&type=template&id=5a52851c&lang=html"
import script from "./ipf-item.vue?vue&type=script&lang=js"
export * from "./ipf-item.vue?vue&type=script&lang=js"
import style0 from "./ipf-item.vue?vue&type=style&index=0&id=5a52851c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports